import React, { FC } from 'react';
import { ObjectHeader, Padding } from '@atlas-frontend/sdk';
import { useClassifierFormCodeAndNameValues } from './useClassifierFormCodeAndNameValues';

export const ClassifierFromLeftSideHeader: FC = () => {
  const { code, name } = useClassifierFormCodeAndNameValues();
  return (
    <Padding>
      <ObjectHeader upperText={code} lowerText={name} />
    </Padding>
  );
};
